import { cloneDeep } from 'lodash';
export default {
	message: state => state.message,
	notified: state => state.notified,
	persons: state => {
		// sort persons alphabetically
		return cloneDeep(state.persons).sort((a, b) => {
			const nameA = a.firstName.toUpperCase(), // ignore upper and lowercase
				nameB = b.firstName.toUpperCase(); // ignore upper and lowercase
			if (nameA < nameB) return -1; //nameA comes first
			if (nameA > nameB) return 1; // nameB comes first
			return 0; // names must be equal
		});
	},
	person: state => cloneDeep(state.person),
	personsByUser: state => cloneDeep(state.personsByUser),
	loading: state => state.loading,
	documentBadge: state => state.documentBadge,
};
